import { useUnit } from 'effector-react'
import { type DateRange } from 'react-day-picker'
import { useQuery } from 'react-query'

import { $creatorId } from '@/models/creators.ts'
import { ppvTrackingService } from '@/modules/tracking/ppv/service/ppv-tracking-service.ts'

interface UsePPVTrackingQuery {
  date?: DateRange | undefined
}

export const usePpvTrackingQuery = ({ date }: UsePPVTrackingQuery) => {
  const creatorId = useUnit($creatorId)

  return useQuery(
    ['ppvTracking', date?.from, date?.to, creatorId],
    () => {
      return ppvTrackingService.getPpvTracking({
        creatorId: creatorId!,
        from: date!.from!,
        to: date!.to!,
      })
    },
    {
      enabled: !!(date?.from && date?.to && creatorId),
    },
  )
}
